import { useQuery } from "@tanstack/react-query";
import { artefactsApi } from "../api/artefacts";

export const useFetchArtefacts = ({ projectId, stageGateId, page, limit, searchKey, assignedToMe, statusFilter, categoryFilter }: { projectId: string | undefined, stageGateId: number | null, page: number, limit: number, searchKey: string | null, assignedToMe: boolean, statusFilter?: string[], categoryFilter?: string[] }) => {

    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: ["artefact-document", projectId, stageGateId, page, limit, searchKey, assignedToMe, statusFilter, categoryFilter],
        queryFn: () => artefactsApi.fetchArtefacts({
            params: {
                page, limit,
                search_term: searchKey,
                project_id: projectId,
                stage_gate_id: stageGateId,
                assign_to_me: assignedToMe,
                status: statusFilter?.length ? statusFilter : undefined,
                category: categoryFilter?.length ? categoryFilter : undefined,
            }
        }),
    });

    return {
        artefactsData: data?.data?.rows,
        artefactsPagination: data?.data?.pagination,
        isPending, isFetching, isError,
        refetch: refetch
    }

};